import { EuroValue, IWelfareOffice } from '@dokucoach/common-types';
import { boolean, date, mixed, object, string } from 'yup';

export type IResidentWelfareOfficeInvoicingConfig = {
  id: string;
  nursingHomeId: string;
  residentId: string;
  validFrom: Date;
  welfareOfficeId: string;
  welfareOffice?: IWelfareOffice;
  costBearerId: string;
  fileReference: string | null;
  coversCostPart: boolean;
  nursingHomeAllowance: number | null;
  privateContribution: number | null;
  socialAssistance: number | null;
  monthlyIncomingSupport: number | null;
  investmentCostSupplement: number | null;
  customCostObjectNumber?: string | null;
  createdAt: Date;
};

export type IResidentWelfareOfficeInvoicingConfigCreate = {
  validFrom: Date;
  welfareOfficeId: string;
  fileReference: string | null;
  coversCostPart: boolean;
  nursingHomeAllowance: number | null;
  privateContribution: number | null;
  socialAssistance: number | null;
  monthlyIncomingSupport: number | null;
  investmentCostSupplement: number | null;
  customCostObjectNumber?: string | null;
};

export type IResidentWelfareOfficeInvoicingConfigUpdate =
  IResidentWelfareOfficeInvoicingConfigCreate;

export const IResidentWelfareOfficeInvoicingConfigCreateSchema = object({
  validFrom: date().required(),
  welfareOfficeId: string().required(),
  fileReference: string().nullable().optional(),
  coversCostPart: boolean().required(),
  nursingHomeAllowance: mixed<number | null>().when('coversCostPart', {
    is: true,
    then: EuroValue.nullable(),
    otherwise: mixed<null>().oneOf([null]),
  }),
  privateContribution: mixed<number | null>().when('coversCostPart', {
    is: true,
    then: EuroValue.nullable(),
    otherwise: mixed<null>().oneOf([null]),
  }),
  socialAssistance: mixed<number | null>().when('coversCostPart', {
    is: true,
    then: EuroValue.nullable(),
    otherwise: mixed<null>().oneOf([null]),
  }),
  monthlyIncomingSupport: mixed<number | null>().when('coversCostPart', {
    is: true,
    then: EuroValue.nullable(),
    otherwise: mixed<null>().oneOf([null]),
  }),
  investmentCostSupplement: EuroValue.nullable(),
  customCostObjectNumber: string().nullable().optional(),
});

export const IResidentWelfareOfficeInvoicingConfigUpdateSchema =
  IResidentWelfareOfficeInvoicingConfigCreateSchema;
